<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


  document.querySelectorAll('.sold-out-badge').forEach(badge => {
  const parent = badge.closest('.card');
  if (parent) {
    parent.style.opacity = '0.4';
  }
});